export const INTELLIGENCE_PAGE_SIZE = 8;

export const INTELLIGENCE_POLL_MS = 15_000;

/** 首页金刚区红点：距上次访问情报社超过该毫秒数则展示 */
export const INTELLIGENCE_HOME_DOT_IDLE_MS = 5 * 60 * 1000;

export const INTELLIGENCE_LAST_VISIT_CACHE = {
  keyPrefix: "longfans-h5.intelLastVisit",
  version: 1,
} as const;

/** 「重要」筛选：importance >= 该值 */
export const INTELLIGENCE_IMPORTANT_MIN = 5;

export function intelligenceImportanceLabel(value: number): string {
  return value >= INTELLIGENCE_IMPORTANT_MIN ? "重要" : "";
}

export function intelligenceCardLevel(value: number): 1 | 2 {
  return value >= INTELLIGENCE_IMPORTANT_MIN ? 2 : 1;
}

export const INTELLIGENCE_NEWS_TYPE_OPTIONS = [
  { type: 0, label: "综合" },
  { type: 1, label: "政策" },
  { type: 2, label: "科技" },
  { type: 3, label: "突发" },
  { type: 4, label: "业绩" },
  { type: 5, label: "风险" },
  { type: 6, label: "行业" },
  { type: 7, label: "资金" },
  { type: 8, label: "大宗" },
  { type: 9, label: "宏观" },
  { type: 10, label: "贸易" },
] as const;

export function intelligenceNewsTypeLabel(type?: number): string {
  return (
    INTELLIGENCE_NEWS_TYPE_OPTIONS.find((option) => option.type === type)?.label ??
    "综合"
  );
}
